// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planday-integration-guide .epi-settings-container .mat-mdc-card.epi-card {
  padding: 16px;
  margin-bottom: 0;
}
.planday-integration-guide .epi-settings-container .mat-mdc-card.epi-card .epi-guide-list {
  padding: 0 16px;
}
.planday-integration-guide .epi-settings-container .mat-mdc-card.epi-card .epi-guide-list .epi-guide-list-item {
  margin-bottom: 18px;
  font-size: 14px;
  line-height: 18px;
}`, "",{"version":3,"sources":["webpack://./Source/app/external-platform-integration/planday/planday-settings/planday-integration-guide/planday-integration-guide.component.scss"],"names":[],"mappings":"AAEQ;EACI,aAAA;EACA,gBAAA;AADZ;AAGY;EACI,eAAA;AADhB;AAGgB;EACI,mBAAA;EACA,eAAA;EACA,iBAAA;AADpB","sourcesContent":[".planday-integration-guide {\r\n    .epi-settings-container {\r\n        .mat-mdc-card.epi-card {\r\n            padding: 16px;\r\n            margin-bottom: 0;\r\n\r\n            .epi-guide-list {\r\n                padding: 0 16px;\r\n\r\n                .epi-guide-list-item {\r\n                    margin-bottom: 18px;\r\n                    font-size: 14px;\r\n                    line-height: 18px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
